import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

export const getSubAdminData = createAsyncThunk(
  "get/subadmin",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("subAdminList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error: error.message });
      rejectWithValue(error);
    }
  }
);
export const addSubAdmin = createAsyncThunk(
  "add/subadmin",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addSubadmin", payload);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Sub admin added failed";
      return rejectWithValue(errorMessage);
    }
  }
);
export const updatesubAdmin = createAsyncThunk(
  "edit/subadmin",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editSubAdmin", payload);
      return response.data;
    } catch (error) {
      console.log({ error: error.message });
      rejectWithValue(error);
    }
  }
);
export const subAdminStatusChanged = createAsyncThunk(
  "statusChanged/subadmin",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        "subadminStatusChanged",
        payload
      );
      return response.data;
    } catch (error) {
      console.log({ error: error.message });
      rejectWithValue(error);
    }
  }
);
const subAdminSlice = createSlice({
  name: "subAdmin",
  initialState: {
    loading: false,
    subAdminData: [],
  },
  extraReducers: (builder) => {
    builder.addCase(getSubAdminData.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getSubAdminData.fulfilled, (state, action) => {
      state.loading = false;
      state.subAdminData = action.payload;
    });
  },
});

export default subAdminSlice.reducer;
